export const SET_AFFILIATE_TOTALS = "SET_AFFILIATE_TOTALS";
export const VISIT_GRAPH = "VISIT_GRAPH";
export const CONVERSATION_GRAPH = "CONVERSATION_GRAPH";
export const PAID_GRAPH = "PAID_GRAPH";
export const UPDATE_BILLING_ADDRESS = "UPDATE_BILLING_ADDRESS";

